module.exports = __webpack_public_path__ + "img/dental5_7-8-2021.d4860e38.jpg";